import termOfConfidentiality from "./termOfConfidentialityOmnik";
import additiveChangeCompany from './companyChangeTerm';
import discharge from './dischargeTerm';
import additiveRenovation from './renewalTerm';
import contract from './serviceProvisionContract';
import distractByTheContractor from './terminationByTheContractor';
import distractMutualAgreement from './terminationMutualAgreement';
import additiveValueAdjustment from './valueAdjustmentTerm';


const templates = {
    additiveChangeCompany: additiveChangeCompany,
    discharge: discharge,
    additiveRenovation: additiveRenovation,
    contract: contract,
    distractByTheContractor: distractByTheContractor,
    distractMutualAgreement: distractMutualAgreement,
    additiveValueAdjustment: additiveValueAdjustment,
    confidentiality: termOfConfidentiality,
    default: ''
}

export default templates;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/docusignDocumentTemplates/index.ts